<template>
  <div>
    <p class="p3 color-green-2 ml-2 mb-4">
      Comunicados ou notificações com data de início igual à data atual serão
      enviados imediatamente após serem salvos.
    </p>
    <b-card border-variant="light" class="custom-card">
      <b-form id="alter-form" class="alter-form">

        <b-form-row>
          <b-col> Titulo DO COMUNICADO </b-col>
          <b-col>
            <b-form-input
              :class="disableField('title') ? 'isDisabled' : ''"
              ref="title"
              v-model.lazy.trim="form.title"
              :state="validateField('title')"
              placeholder="Informe o titulo do comunicado"
            />
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col> DATA INÍCIO </b-col>
          <b-col>
            <date-picker
              :disabled="disableField('dateStart')"
              datePickerId="dateStart"
              :key="getKeyDate(form.dateStart)"
              :dataValue="form.dateStart"
              :state="validateFieldStartDate('dateStart', true)"
              @datePickerChangedValue="onChangedDateStart"
            />
          </b-col>
          <div
            class="invalid text-invalid-right"
            v-show="
              (isValideStartDate == false && (isToClone || !form.id)) ||
              validateFieldStartDate('dateStart', true) == false
            "
          >
            {{ startDateErrorMsg }}
          </div>
        </b-form-row>
        <b-form-row>
          <b-col> DATA FIM </b-col>
          <b-col>
            <date-picker
              :disabled="disableField('dateEnd')"
              datePickerId="dateEnd"
              :key="getKeyDate(form.dateEnd)"
              :state="validateFieldEndDate('dateEnd', 'dateStart', false)"
              :dataValue="form.dateEnd"
              @datePickerChangedValue="onChangedDateEnd"
            />
          </b-col>
          <div
            class="invalid text-invalid-right"
            v-show="
              validateFieldEndDate('dateEnd', 'dateStart', false) == false
            "
          >
            {{ endDateErrorMsg }}
          </div>
        </b-form-row>
        <b-form-row>
          <b-col> FREQUÊNCIA DE ENVIO </b-col>
          <b-col>
            <b-form-select
              :disabled="disableField('shippingFrequency')"
              v-model.lazy.trim="form.shippingFrequency"
              :state="validateField('shippingFrequency')"
              :options="shippingFrequencyOptions"
              v-on:change="onChangeShippingFrequency(form.shippingFrequency)"
            />
          </b-col>
        </b-form-row>
        <b-form-row
          v-if="
            form.shippingFrequency != null &&
            form.shippingFrequency != 'NOT_REPEATED'
          "
        >
          <b-col> PARÂMETRO DE REPETIÇÃO </b-col>
          <b-col>
            <b-form-select
              :disabled="disableField('paramFrequency')"
              v-model.lazy.trim="form.paramFrequency"
              :state="this.checkParamFrequency"
              :options="paramFrequencyOptions"
              v-on:change="onChangeFileType(form.paramFrequency)"
            />
          </b-col>
        </b-form-row>
        <b-form-row
          v-if="
            form.paramFrequency != null &&
            form.paramFrequency != 'VISUALIZATION'
          "
        >
          <b-col>
            FREQUÊNCIA DE EXIBIÇÃO (ATÉ
            {{
              shippingFrequencyOptions.filter(
                (sf) => sf["value"] == form.shippingFrequency,
              )[0].maxDays
            }}
            DIAS)
          </b-col>
          <b-col>
            <b-form-input
              :class="disableField('periodToShow') ? 'isDisabled' : ''"
              ref="periodToShow"
              @keypress="onlyNumber"
              v-model.lazy.trim="periodToShow"
              :state="ckeckPeriodToShow"
            />
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col> DISPONIBILIZAR PARA TODOS OS COOPERADOS </b-col>
          <b-col class="custom-align">
            <b-form-checkbox
              class="ml-auto align-right-all-time custom-recipient"
              :disabled="disableField('allRecipient')"
              switch
              v-model="form.allRecipient"
              @change="this.onChangedAllRecipient"
            >
              {{ form.allRecipient ? "Sim" : "Não" }}
            </b-form-checkbox>
          </b-col>
        </b-form-row>
        <b-form-row v-if="!form.allRecipient">
          <b-col> CRM(S) </b-col>
          <b-col class="custom-align">
            <MultiSelectCrm
              :id="1"
              :disabled="disableField('crms')"
              @onSelectCrm="onSelectCrm"
              :crms="form.crms"
            />
          </b-col>
        </b-form-row>
        <!-- <b-form-row v-if="!form.allRecipient">
          <b-col> ESPECIALIDADE(S) </b-col>
          <b-col class="custom-align">
            <MultiSelectSpecialties
              :key="selectSpecialtiesKey"
              :id="2"
              :disabled="disableField('specialties')"
              @onSelect="onSelectSpecialities"
              :items="form.specialties"
            />
          </b-col>
        </b-form-row> -->
        <b-form-row>
          <b-col> MENSAGEM DE SAUDAÇÃO </b-col>
          <b-col>
            <b-form-input
              :class="disableField('greetingMessage') ? 'isDisabled' : ''"
              ref="greetingMessage"
              v-model.lazy.trim="form.greetingMessage"
              :state="validateField('greetingMessage')"
              placeholder="Informe a mensagem “Ex: OLÁ”"
            />
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col class="text-size-mobile pb-3" ref="descriptionText">
            TEXTO
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col>
            <vue-editor
              class="custom-editor"
              v-model="form.text"
              v-if="!disableField('text')"
            />
            <b-form-textarea
              v-if="disableField('text')"
              id="textarea-1"
              :class="disableField('text') ? 'isDisabled' : ''"
              v-model="form.text"
              class="custom-textarea"
              :state="validateField('text')"
              placeholder="Informe o texto…"
              rows="5"
            ></b-form-textarea>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col> TEXTO BOTÃO CONFIRMAÇÃO </b-col>
          <b-col>
            <b-form-input
              :class="disableField('textButton') ? 'isDisabled' : ''"
              ref="textButton"
              v-model.lazy.trim="form.textButton"
              :state="validateField('textButton')"
              placeholder="Informe o texto “Ex: Estou ciente!””"
            />
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col> TEXTO BOTÃO DO LINK </b-col>
          <b-col>
            <b-form-input
              :class="disableField('textLink') ? 'isDisabled' : ''"
              ref="textLink"
              v-model.lazy.trim="form.textLink"
              placeholder="Informe o texto"
            />
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col> LINK DO BOTÃO </b-col>
          <b-col>
            <b-form-input
              :class="disableField('linkToRedirect') ? 'isDisabled' : ''"
              ref="linkToRedirect"
              v-model.lazy.trim="form.linkToRedirect"
              :state="validateField('linkToRedirect')"
              placeholder=""
            />
          </b-col>
        </b-form-row>

        <b-form-row v-if="!disableField('uploadFile')">
          <b-col class="">
            <upload-file
              @updateFile="eventToUpdateFile"
              :multiple="false"
              :description="'Anexar imagem'"
              :msgErro="'É necessário inserir o arquivo.'"
              accept="image/png,image/jpeg"
              :required="false"
              ref="upload"
              v-model.lazy.trim="form.files"
            />
          </b-col>
        </b-form-row>
      </b-form>
    </b-card>
    <b-row
      class="my-5 d-flex content-between justify-content-between custom-buttons"
    >
      <div>
        <b-button
          variant="outline-primary"
          :disabled="this.loading"
          @click="this.onCancel"
          class="ml-4"
        >
          Cancelar
        </b-button>

        <b-button
          form="alter-form"
          type="button"
          class="ml-4"
          variant="primary"
          id="submitButtonText"
          :disabled="this.loading"
          @click="() => this.onSubmitHandler(false)"
        >
          {{ this.getButtonLabel() }}
        </b-button>
      </div>
    </b-row>
    <report-success-modal
      ref="success-modal"
      description="O comunicado foi salvo com sucesso."
      :onAction="this.onActionConfirm"
      cancelButtonText="Ok, entendi!"
    />
  </div>
</template>
<script>
import _ from "lodash";
import ReportSuccessModal from "../../../components/base-modals/ReportSuccessModal.vue";
import UploadFile from "../../../components/upload-file/UploadFile.vue";
import MultiSelectCrm from "../../../components/multiselect-crm/MultiSelectCrm.vue";
import DatePicker from "../../../components/date-picker/DatePicker.vue";
import {
  createCommunication,
  getCommunicationById,
  updateCommunicationById,
} from "../../../services/communication/communication";
import { inject } from "@vue/composition-api";
import {
  validateField,
  validateFieldEndDate,
  validateFieldStartDate,
  validateFieldStartDateOnChange,
  requiredFieldsFilled,
} from "../../../utils/validate/validate.js";
import { createToast } from "../../../components/toast/toast";
import RoutesPaths from "../../../router/router-structure/routes-paths";
//import MultiSelectSpecialties from "../../../components/multiselect-specialties/MultiSelectSpecialties.vue";
import { VueEditor } from "vue2-editor";

const DefaultForm = {
  id: null,
  title: null,
  dateStart: null,
  dateEnd: null,
  allRecipient: false,
  crms: [],
  specialties: [],
  greetingMessage: null,
  text: null,
  textButton: null,
  textLink: null,
  linkToRedirect: null,
  shippingFrequency: null,
  files: [],
  apresentationSequence: 0,
  type: "COMMUNICATION",
};

const ShippingFrequency = [
  { value: null, text: "Selecione a frequência", disabled: true },
  { value: "NOT_REPEATED", text: "Não repete" },
  { value: "WEEKLY", text: "Semanal", maxDays: 7 },
  { value: "MONTHLY", text: "Mensal", maxDays: 31 },
  { value: "SEMIANNUALLY", text: "Semestral", maxDays: 186 },
  { value: "ANNUAL", text: "Anual", maxDays: 365 },
];

const Types = [
  { value: null, text: "Selecione", disabled: true },
  { value: "NOTIFICATION", text: "Notificação" },
  { value: "COMMUNICATION", text: "Comunicado" },
  { value: "NOTIFICATION_AND_COMMUNICATION", text: "Comunicado e Notificação" },
];

const ParamFrequency = [
  { value: "VISUALIZATION", text: "Data de ciência do Cooperado" },
  { value: "CREATE", text: "Data de início da vigência" },
];

export default {
  name: "communicatiom-manegement-form-view",
  props: ["onChangeTab", "index"],
  components: {
    DatePicker,
    MultiSelectCrm,
    //MultiSelectSpecialties,
    UploadFile,
    ReportSuccessModal,
    VueEditor,
  },
  watch: {
    periodToShow: {
      handler: _.debounce(function () {
        this.onCheckSizePeriod();
      }, 300), // Espera 300ms antes de chamar a função
      immediate: false,
    },
  },
  setup() {
    const globalLoading = inject("globalLoading");
    return { globalLoading };
  },
  async mounted() {
    this.isToClone = this.$route.query.toClone == "true";
    this.form = { ...DefaultForm };
    this.globalLoading = true;
    try {
      if (this.$route.params.id) {
        this.communication = await getCommunicationById(this.$route.params.id);
        if (this.communication.linkImage) {
          const response = await fetch(this.getLink(this.communication));
          const { filename, mimeType } = await this.getFilename(response.url);
          const blob = await response.blob();
          const file = new File([blob], filename, { type: mimeType });
          this.form = {
            ...this.form,
            files: [file],
          };
          if (this.communication.action.canUpdateAll) {
            this.$refs.upload.files = [file];
          }
        }
        this.buildCommunication();
        this.selectSpecialtiesKey++;
      }
      this.globalLoading = false;
    } catch (error) {
      this.globalLoading = false;
      console.error("mounted", error);
      createToast("Atenção", "Ocorreu um erro carregar as informações.");
    }
  },
  data() {
    return {
      periodToShow: 0,
      form: { ...DefaultForm },
      formSubmited: false,
      communication: { action: { canUpdateAll: true } },
      validations: {},
      shippingFrequencyOptions: ShippingFrequency,
      typeOptions: Types,
      paramFrequencyOptions: ParamFrequency,
      loading: false,
      validateField,
      validateFieldStartDate,
      validateFieldStartDateOnChange,
      isValideStartDate: null,
      validateFieldEndDate,
      requiredFieldsFilled,
      endDateErrorMsg: "",
      startDateErrorMsg: "",
      isToClone: false,
      checkParamFrequency: null,
      ckeckPeriodToShow: null,
      selectSpecialtiesKey: 0,
    };
  },
  methods: {
    onChangeFileType(value) {
      this.form = { ...this.form, paramFrequency: value };
    },
    onCheckSizePeriod() {
      const periodMaxDays = this.shippingFrequencyOptions.filter(
        (sf) => sf["value"] == this.form.shippingFrequency,
      )[0].maxDays;

      if (this.periodToShow > periodMaxDays) {
        this.periodToShow = periodMaxDays;
        this.form = { ...this.form, periodToShow: this.periodToShow };
      }
    },
    onChangeType(type) {
      this.form = { ...this.form, type };
    },
    onChangeShippingFrequency(shippingFrequency) {
      if ("NOT_REPEATED" == shippingFrequency) {
        this.form = { ...this.form, paramFrequency: null };
      }
    },
    onlyNumber(event) {
      const key = event.key;
      if (!/^\d$/.test(key)) {
        event.preventDefault();
      }
    },
    disableField(fieldName) {
      if (this.isToClone) {
        return false;
      }

      if (!this.communication?.action) {
        return false;
      }

      if (this.communication.action.isCurrent) {
        if (fieldName == "dateEnd") {
          return false;
        } else return true;
      }

      return !this.communication.action.canUpdateAll;
    },
    getButtonLabel() {
      const id = !!this.$route.params.id;
      if (this.isToClone) {
        return "Clonar comunicado";
      } else if (id) {
        return "Salvar";
      }
      return "Salvar";
    },
    async getFilename(url) {
      const mimeTypes = {
        png: "image/png",
        jpg: "image/jpeg",
        jpeg: "image/jpeg",
      };
      const decodedUrl = decodeURIComponent(url);
      const filename = decodedUrl.split("/").pop().split("?")[0];
      const ext = filename.split(".").pop().toLowerCase();
      const mimeType = mimeTypes[ext] || "application/octet-stream"; // Padrão para tipos desconhecidos

      return { filename, mimeType };
    },
    getLink({ linkImage }) {
      if (this.$store.getters.isApp) {
        return linkImage.replace("https", "http");
      } else {
        return linkImage;
      }
    },
    eventToUpdateFile(files) {
      this.form.files = files;
    },
    onSelectCrm(crms) {
      this.form.crms = crms;
    },
    onSelectSpecialities(items) {
      this.form.specialties = items;
    },
    onChangedDateStart(value) {
      this.form.dateStart = value;
      //Futuro somente para cadastro e clonagem
      const onlyFuture = this.isToClone || !this.form.id;
      this.isValideStartDate = this.validateFieldStartDateOnChange(
        "dateStart",
        onlyFuture,
      );
      if (this.isValideStartDate) {
        this.validateFieldEndDate("dateEnd", "dateStart", false);
      }
    },
    onChangedDateEnd(value) {
      this.form.dateEnd = value;
    },
    buildCommunication() {
      this.form.id = this.communication.id;
      this.form.title = this.communication.title;
      this.form.type = this.communication.type;
      this.form.dateStart = this.communication.dateStart;
      this.form.dateEnd = this.communication.dateEnd;
      this.form.shippingFrequency = this.communication.shippingFrequency;
      this.form.textButton = this.communication.textButton;
      this.form.textLink = this.communication.textLink;
      this.form.linkToRedirect = this.communication.linkToRedirect;
      this.form.allRecipient = this.communication.allRecipient;
      this.form.text = this.communication.text;
      this.form.greetingMessage = this.communication.greetingMessage;
      this.form.crms = this.communication.crms;
      this.form.specialties = this.communication.specialties;
      this.form.paramFrequency = this.communication.paramFrequency;
      this.form.periodToShow = this.communication.periodToShow;
      this.periodToShow = this.communication.periodToShow;
    },
    getKeyDate(date) {
      return date?.toString();
    },
    onChangedAllRecipient() {
      this.form = { allRecipient: !this.form.allRecipient, ...this.form };
    },
    availableOptions(specialties) {
      return [
        ...specialties
          .filter((opt) => this.form.specialties.indexOf(opt) === -1)
          .map((sp) => ({
            value: sp,
            text: sp.name,
          })),
      ];
    },
    onRequiredFieldsFilled() {
      this.checkParamFrequency = null;
      this.ckeckPeriodToShow = null;
      if (
        this.form.shippingFrequency != null &&
        this.form.shippingFrequency != "NOT_REPEATED"
      ) {
        this.checkParamFrequency = !!this.form.paramFrequency;
      }

      if (
        this.form.paramFrequency != null &&
        this.form.paramFrequency != "VISUALIZATION"
      ) {
        this.ckeckPeriodToShow = !!this.form.paramFrequency;
      }

      return (
        (this.ckeckPeriodToShow == null || this.ckeckPeriodToShow) &&
        (this.checkParamFrequency == null || this.checkParamFrequency) &&
        this.requiredFieldsFilled()
      );
    },
    async onSubmitHandler() {
      this.formSubmited = true;
      this.form.periodToShow = this.periodToShow;

      if (this.onRequiredFieldsFilled()) {
        this.loading = true;

        try {
          const id = !!this.$route.params.id;
          const payload = {
            ...this.form,
            name: this.form.title,         // Mapeia 'title' para 'name'
            description: this.form.text    // Mapeia 'text' para 'description'
          };
          if (id && !this.isToClone) {
            await updateCommunicationById(payload);
          } else {
            await createCommunication(payload);
          }

          const modal = this.$refs["success-modal"].$children[0];
          modal.show();
        } catch (error) {
          this.loading = false;
          if (error.response.data.error_code === "COMMUNICATION_NOT_UPDATE") {
            const delay = 120000000;
            createToast(
              "Informação",
              error.response.data.message,
              "info",
              delay,
            );
          } else {
            console.error("onSubmit", error);
            createToast(
              "Atenção",
              "Ocorreu um erro ao salvar informações do comunicado.",
            );
          }
        }

        this.loading = false;
      }
    },
    onActionConfirm() {
      this.onCancel();
    },
    onCancel() {
      this.$router.push(RoutesPaths.communicationManagement.rootName());
    },
  },
};
</script>

<style lang="scss" scoped>
.align-right-all-time {
  position: absolute;
  right: 4px;
}
.b-form-tags-input {
  font-size: 1.2rem;
}
.b-form-tag-content {
  font-size: 1.1rem;
}
.b-form-tag > button.b-form-tag-remove {
  font-size: 180%;
}
.text-invalid-right {
  width: 100%;
  text-align: right;
}
.custom-align {
  margin-right: 1rem;
}
.custom-textarea {
  color: var(--dark-0) !important;
  font-size: 1.4rem !important;
}
.isDisabled {
  pointer-events: none;
  cursor: pointer;
  text-decoration: none;
  opacity: 0.6;
}
.custom-recipient {
  color: var(--dark-0) !important;
}

.custom-editor {
  text-transform: none;
  width: 100%;
}
</style>
